export default {
  namespaced: true,

  state: () => ({
    selectedClasses: [],
  }),

  getters: {
    classIds: (state) =>
      state.selectedClasses.map((selectedClass) => selectedClass.id),
    assignmentIds: (state) =>
      state.selectedClasses.flatMap((selectedClass) =>
        (selectedClass.assignments || []).map((assignment) => assignment.id)
      ),
  },

  mutations: {
    setSelections(state, selectedClasses) {
      state.selectedClasses = selectedClasses;
    },

    clear(state) {
      state.selectedClasses = [];
    },
  },
};
